import type { MainGuestDropdownOption } from '../model/types';
import type { IParticipant, Ticket } from '@pages/event/api/useFetchTicketSegment';
import type { ISegmentParticipants } from '@features/add-participants-modal';

const getUniqueParticipantsWithTicketId = (
  segments: ISegmentParticipants[] | null | undefined
): { participant: IParticipant; ticketId: number }[] => {
  const result: { participant: IParticipant; ticketId: number }[] = [];
  const seenIds = new Set<number>();
  for (const segment of segments ?? []) {
    const tickets = (segment as { tickets?: Ticket[] }).tickets ?? segment.participants ?? [];
    for (const ticket of tickets) {
      const participant = ticket?.participant;
      const ticketId = (ticket as { id?: number }).id;
      if (!participant || ticketId == null || seenIds.has(participant.id)) continue;
      seenIds.add(participant.id);
      result.push({ participant, ticketId });
    }
  }
  return result;
};

export const getMainGuestOptionsFromSegments = (
  segments: ISegmentParticipants[] | null | undefined
): MainGuestDropdownOption[] =>
  getUniqueParticipantsWithTicketId(segments).map(({ participant, ticketId }) => ({
    id: String(ticketId),
    label: [participant.lastName, participant.firstName, participant.surname].filter(Boolean).join(' ').trim(),
    ticketId,
  }));
